import { mergeUniforms } from "three/src/renderers/shaders/UniformsUtils.js";
import TochiShader from "./TochiShader";
import { SkinChunk, DecalChunk } from "./TochiShaderChunks";

export const GradientMaskShader = (
  len: number,
  isDecal: boolean
): TochiShader => {
  return {
    uniforms: mergeUniforms([
      SkinChunk.uniforms,
      isDecal ? DecalChunk.uniforms : {},
      {
        mask: { value: null },
        colors: { value: null },
        colorPos: { value: null },
      },
    ]),
    vertexShader: `
        #include <tochi_skin_vert_premain>
        void main() {
          #include <tochi_skin_vert_main>
        }
    `,
    fragmentShader: `
        #define numColors ${len}
        #define isDecal ${isDecal}
        uniform sampler2D mask;
        uniform vec3 colors[numColors];
        uniform float colorPos[numColors];
        varying vec2 vUv;

        #include <tochi_skin_frag_premain>
        #include <tochi_decal_frag_premain>
        #include <tochi_colorlerp_frag_premain>
        
        void main(){
            // Get luma
            vec4 tex = texture2D(mask, vUv);
            float l = dot(tex.rgb, vec3(0.2126, 0.7152, 0.0722));
        
            vec3 col = vec3(0.);
            for (int i=0; i < numColors; i++){
                col +=  color_lerp(colors, colorPos, numColors, l,  i); 
            }    
            vec4 diffuseColor = vec4(col, tex.a);
            gl_FragColor = diffuseColor;
            if (isDecal) {
              #include <tochi_decal_frag_main>
            }
            #include <tochi_skin_frag_main>
        }
    `,
  };
};
